/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-07-24 19:15:37
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-08-20 15:35:47
 * @FilePath: \mpc-2\apps\mpc-external\src\containers\App\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import './index.less';
import React, { Component } from 'react';
import { Route, Switch, RouteComponentProps, withRouter, Redirect } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { locales } from 'utils';
import localMessages from '../../localMessages';
import { LocaleProvider } from '@beehive/components';
// import Main from '../Main';
import Main from '../Main/newIndex';
import Login from '../Login';
import ForgetPwd from '../Login/ForgetPwd';
import ResetPwd from '../Login/ResetPwd';
import { datrack } from '@mpc/common/src/utils/datracker';

class App extends Component<RouteComponentProps, any> {
  componentDidMount() {
    const { history } = this.props;
    history.listen((location) => {
      datrack('page_change', {
        href: window.location.href,
        title: document.title,
      });
    });
    document.body?.classList?.add?.('mpc');
  }

  public render() {
    const locale = 'zh-CN';
    return (
      <IntlProvider locale={locale} messages={localMessages[locale]} key={locale}>
        <LocaleProvider locale={{ locale: locales[locale] }}>
          <Switch>
            <Redirect path="/login" from="/login" to="/" />
            <Route path="/forget" component={ForgetPwd} />
            <Route path="/reset" component={ResetPwd} />

            <Route path="/" component={Main} />
          </Switch>
        </LocaleProvider>
      </IntlProvider>
    );
  }
}

export default withRouter(App);
